import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=aa744e60&scoped=true&"
import script from "./Profile.vue?vue&type=script&lang=js&"
export * from "./Profile.vue?vue&type=script&lang=js&"
import style0 from "./Profile.vue?vue&type=style&index=0&id=aa744e60&prod&lang=scss&scoped=true&"
import style1 from "./Profile.vue?vue&type=style&index=1&id=aa744e60&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa744e60",
  null
  
)

export default component.exports